import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

export const ActivityTruncationBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      testID='activity-truncation-banner'
      flexDirection='row'
      alignItems='center'
      backgroundColor='yellowVividMild'
      paddingHorizontal='m'
      paddingVertical='xs'
      gap='xs'>
      <Icon name='AlertTriangle' variant='s' color='textPrimary' />
      <Text variant='labelSmall' color='textPrimary' flex={1}>
        {t('shared:activityResultsTruncated')}
      </Text>
    </Box>
  );
};
